import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Nav, NavbarToggler, NavbarBrand, Badge, NavItem, NavLink } from 'reactstrap'
import HeaderDropdown from './HeaderDropdown'
import { Route } from 'react-router-dom'

class Header extends Component {
  constructor() {
    super()
    this.asideToggle = this.asideToggle.bind(this)
  }

  static propTypes = {
    onAsideToggle: PropTypes.func.isRequired,
    notifyCount: PropTypes.number.isRequired
  }

  sidebarToggle(e) {
    e.preventDefault()
    document.body.classList.toggle('sidebar-hidden')
    const resizeEvent = document.createEvent('HTMLEvents')
    resizeEvent.initEvent('resize', true, false)
    window.dispatchEvent(resizeEvent)
    setTimeout(() => {
      window.dispatchEvent(resizeEvent)
    }, 500)
  }

  mobileSidebarToggle(e) {
    e.preventDefault()
    document.body.classList.toggle('sidebar-mobile-show')
  }

  asideToggle(e) {
    e && e.preventDefault()
    document.body.classList.toggle('aside-menu-hidden')
    const resizeEvent = document.createEvent('HTMLEvents')
    resizeEvent.initEvent('resize', true, false)
    window.dispatchEvent(resizeEvent)
    setTimeout(() => {
      window.dispatchEvent(resizeEvent)
    }, 500)

    this.props.onAsideToggle()
  }

  render() {
    const isStaging = window.location.hostname.includes('staging')

    return (
      <header className="app-header navbar">
        <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>
          <span className="navbar-toggler-icon" />
        </NavbarToggler>
        <NavbarBrand href="/dashboard" refresh="true"> </NavbarBrand>
        <NavbarToggler className="d-md-down-none" onClick={this.sidebarToggle}>
          <span className="navbar-toggler-icon" />
        </NavbarToggler>
        {isStaging && <div className="position-absolute w-100 text-center font-weight-bold text-danger" style={{ fontSize: '3rem', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>Test Version (Staging Environment)</div>}
        <Nav className="ml-auto" navbar>
          <Route path="/:path" component={HeaderDropdown} />
          {this.props.notifyCount !== 0 &&
            <NavItem className="d-md-down-none">
              <NavLink href="#" onClick={this.asideToggle}><i className="icon-bell" />
                <Badge pill color="danger">{this.props.notifyCount}</Badge>
              </NavLink>
            </NavItem>
          }
        </Nav>
        <NavbarToggler id="aside-panel" className="d-md-down-none" onClick={this.asideToggle}>
          <span className="navbar-toggler-icon" />
        </NavbarToggler>
      </header>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js